import { useTranslate } from '@tolgee/react';
import TablePage, {
  TablePageProps,
  getServerSideProps as fetcher,
} from '@amf/shared/pages/TablePage';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';
import { AppLinks } from 'utils/links';

function Page({ navigation, partners, seasons }: TablePageProps) {
  const { t } = useTranslate();
  return (
    <Layout navigation={navigation} partners={partners}>
      <Meta title={t('table.list.title')} />
      <TablePage seasons={seasons} links={{ match: AppLinks.match, team: AppLinks.team }} />
    </Layout>
  );
}

export default Page;

export const getServerSideProps = fetcher();
